import React from "react";
import type { CardNetwork } from "./cardBrandUtils";

type Props = {
  network: CardNetwork;
  className?: string;
  height?: number;
  variant?: "light" | "dark";
};

const CardNetworkLogo: React.FC<Props> = ({
  network,
  className = "",
  height = 28,
  variant = "light",
}) => {
  const textFill = variant === "light" ? "#fff" : "#162D3A";
  const mutedStroke = variant === "dark" ? "rgba(22,45,58,0.25)" : "rgba(255,255,255,0.35)";

  if (network === "visa") {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        viewBox="0 0 48 16"
        aria-label="Visa"
        role="img"
      >
        <text x="0" y="13" fill={textFill} fontSize="14" fontWeight="700" fontFamily="Arial, sans-serif">
          VISA
        </text>
      </svg>
    );
  }

  if (network === "mastercard") {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        width={height * 1.5}
        viewBox="-96 -98.908 832 593.448"
        aria-label="Mastercard"
        role="img"
      >
        <path fill="#ff5f00" d="M224.833 42.298h190.416v311.005H224.833z" />
        <path
          d="M244.446 197.828a197.448 197.448 0 0175.54-155.475 197.777 197.777 0 100 311.004 197.448 197.448 0 01-75.54-155.53z"
          fill="#eb001b"
        />
        <path
          d="M640 197.828a197.777 197.777 0 01-320.015 155.474 197.777 197.777 0 000-311.004A197.777 197.777 0 01640 197.773z"
          fill="#f79e1b"
        />
      </svg>
    );
  }

  if (network === "amex") {
    return (
      <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={height}
        viewBox="0 0 48 16"
        aria-label="American Express"
        role="img"
      >
        <rect width="48" height="16" rx="2" fill="#2E77BC" />
        <text x="4" y="11" fill="#fff" fontSize="7" fontWeight="700" fontFamily="Arial, sans-serif">
          AMEX
        </text>
      </svg>
    );
  }

  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      height={height}
      width={height * 1.5}
      viewBox="0 0 36 24"
      aria-hidden
    >
      <rect
        x="1"
        y="4"
        width="34"
        height="16"
        rx="3"
        fill="none"
        stroke={mutedStroke}
        strokeWidth="1.5"
      />
    </svg>
  );
};

export default CardNetworkLogo;
